<template>
  <div class="container center w100 relative-container">
    <div class="padded">
      <step-counter class="tablet" paso="2" />
      <wrap-container class="cascade w50">
        <form-validator>
          <wrap-container>
            <p
              id="titulo"
              class="titulo p32 medium oscuro"
              v-safe-html="config.pasos.paso2.titulo"
            />
            <p
              id="subtitulo"
              class="titulo oscuro"
              v-safe-html="config.pasos.paso2.subtitulo"
            />
          </wrap-container>
          <wrap-container>
            <employment-situation
              class="margin-btn-24"
              v-model="model.situacionLaboral"
              quantumObfuscate
            />
            <job-occupation
              class="margin-btn-24"
              v-model="model.ocupacion"
              :situacionLaboral="model.situacionLaboral"
              quantumObfuscate
            />
          </wrap-container>
          <wrap-container>
            <work-activity
              class="margin-btn-24"
              v-model="model.actividad"
              :situacionLaboral="model.situacionLaboral"
              quantumObfuscate
            />
            <net-income
              class="ingreso"
              v-model="model.ingresoNeto"
              quantumObfuscate
            />
          </wrap-container>
          <wrap-container>
            <cuil-type
              class="margin-btn-24"
              v-show="showSelectTipoCuild"
              v-model="model.tipoCuil"
              :situacionLaboral="model.situacionLaboral"
              quantumObfuscate
            />
          </wrap-container>
          <wrap-container>
            <cuil-input
              class="margin-btn-24"
              v-model="model.cuil"
              :type="model.tipoCuil"
              :required="true"
              maxlength="11"
              quantumObfuscate
            />
          </wrap-container>
          <step-navigator
            v-model="model"
            :store-action="this.doNext"
            analyticsName="continuar"
          />
        </form-validator>
      </wrap-container>
      <wrap-container class="cascade w50"></wrap-container>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import StepCounter from "@/components/core/StepCounter";
import EmploymentSituation from "@/components/core/composite/combos/EmploymentSituation";
import JobOccupation from "@/components/core/composite/combos/JobOccupation";
import WorkActivity from "@/components/core/composite/combos/WorkActivity";
import StepNavigator from "@/components/core/StepNavigator";
import { DO_PASO2 } from "../config/constants/action-types";
import CuilInput from "@/components/core/composite/CuilInput";
import { cuilGen } from "@/utils";
import CuilType from "@/components/core/composite/combos/CuilType";

export default {
  name: "Paso2",
  components: {
    WrapContainer,
    FormValidator,
    StepCounter,
    EmploymentSituation,
    JobOccupation,
    WorkActivity,
    CuilInput,
    StepNavigator,
    CuilType
  },
  data() {
    return {
      model: this.$store.getters.getPaso2(),
      situacionLaboral: this.$store.getters.getPaso2().situacionLaboral,
      doNext: DO_PASO2
    };
  },
  mounted() {
    /* Si no hay oferta... Vuelvo a la consulta */
    if (PRODUCTION && !this.$store.state.dataOferta.oferta.valid) {
      this.$router.push("/");
      return;
    }
    // Generar CUIL
    if (this.model.cuil === "") {
      this.model.cuil = cuilGen(
        this.$store.getters.getConsulta().numeroDoc,
        this.$store.getters.getConsulta().sexo
      );
    }
  },
  computed: {
    showSelectTipoCuild() {
      return this.model.situacionLaboral === "002";
    }
  }
};
</script>
<style scoped>
#titulo {
  margin-bottom: 5px;
}

.margin-btn-24 {
  margin-bottom: 24px;
}

.ingreso {
  margin-bottom: 40px;
}

#subtitulo {
  font-size: 15px;
  line-height: 24px;
  margin-bottom: 40px;
}

@media screen and (max-width: 600px) {
  #titulo {
    font-size: 26px;
    margin-bottom: 10px;
  }
}

@media screen and (min-width: 601px) and (max-width: 1024px) {
  .w50 {
    width: 80%;
    max-width: 1024px;
    margin-left: 10%;
    margin-right: 10%;
  }

  .cascade {
    display: block;
  }

  .tablet {
    margin-left: 10%;
  }
}
</style>
